import { get } from 'underscore';
import { edmCampaign } from '@bingads-webui/edm-campaign';

const generalErrString = _TL_('Request failed for uncertain reason, please try again later');

const ErrorCodeMapping = {
  ConsentModeDecisionAlreadyExist: _TL_('Consent mode decision already exists, if you need to change your selection, please contact Microsoft Advertising support.'),
  SendConsentModeEmailFailed: _TL_('Sending email fails, please try again later'),
  WriteConsentModeDecisionFailed: _TL_('Updating your consent mode decision fails, please try again later'),
};

export const getErrorCode = err => get(err, ['responseJSON', 'value', 0, 'Code']);

export const getErrorMessage = (err) => {
  const firstErrorCode = getErrorCode(err);
  return ErrorCodeMapping[firstErrorCode] || generalErrString;
};

export const getConsentModeDialogStatus = cid => edmCampaign
  .Customers.$withKey(cid)
  .Accounts['Default.UETConsentModeStatus']
  .get().toPromise().then(response => response).catch(error => Promise.reject(error));

export const updateConsentModeDecision = (cid, payload) => edmCampaign
  .Customers.$withKey(cid)
  .Accounts['Default.UpdateConsentModeDecision']
  .$makeCall({
    payload,
  }).toPromise().then(response => response).catch(error => Promise.reject(error));
